<app-key-info [staffMode]="true" storageKeyPrefix="cp-activationView-"></app-key-info>